import logo from './ninjacat.png';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          We sell Ninja Kittens. And Ninjas. Meow.
        </p>
        <a
          className="App-link"
          href="https://reactjs.org"
          target="_blank"
          rel="noopener noreferrer"
        >
          Buy more kittens here. 
        </a>
      </header>
    </div>
  );
}

export default App;
